import { useEffect, useRef } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { dispatch } from 'store';
import { setUserData } from 'store/slices/user';
import { clearAppMeBootstrap, loadAppUserProfile } from 'utils/auth/loadAppUserProfile';

export default function AuthSync() {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const ran = useRef(false);

  useEffect(() => {
    const run = async () => {
      if (!isLoaded) return;
      if (!isSignedIn) {
        ran.current = false;
        dispatch(setUserData(null));
        clearAppMeBootstrap();
        return;
      }

      // StrictMode safe: only once per successful /me — reset on error so a later navigation can retry
      if (ran.current) return;
      ran.current = true;

      try {
        const me = await loadAppUserProfile();
        if (!me) {
          ran.current = false;
          return;
        }

        // ✅ Your route is /company-onboarding (from MainRoutes.tsx)
        const onboardingPath = '/company-onboarding';

        if (me.needsOnboarding && location.pathname !== onboardingPath) {
          navigate(onboardingPath, { replace: true });
        }
      } catch (e) {
        ran.current = false;
        if (import.meta.env.DEV) {
          console.warn('[AuthSync] /api/users/me failed — menu and user state may be incomplete until the request succeeds.', e);
        }
      }
    };

    void run();
  }, [isLoaded, isSignedIn, navigate, location.pathname]);

  return null;
}
